import type React from 'react';
import classnames from 'classnames';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import styles from '../styles.module.css';
import type { ScrollDirection } from '../types';

interface ScrollArrowProps {
  direction: ScrollDirection;
  iconSize?: number;
  isVisible: boolean;
  onClick: () => void;
}

export const ScrollArrow: React.FC<ScrollArrowProps> = ({ direction, iconSize = 28, isVisible, onClick }) => {
  const Icon = direction === 'left' ? ChevronLeft : ChevronRight;
  const arrowClass = direction === 'left' ? styles.leftArrow : styles.rightArrow;

  return (
    <button
      aria-hidden={!isVisible}
      aria-label={`Scroll ${direction}`}
      className={classnames(styles.arrow, arrowClass)}
      disabled={!isVisible}
      onClick={onClick}
      tabIndex={isVisible ? 0 : -1}
      type="button"
    >
      <Icon aria-hidden="true" size={iconSize} />
    </button>
  );
};
